import React from "react";
import styled from "styled-components";
// Components
import PricingTable from "../Elements/PricingTable";

export default function Pricing() {
  return (
    <Wrapper id="pricing">
      <div className="container">
        <HeaderInfo>
          <h1 className="font40 extraBold">Our Web Development Pricing Plans</h1>
          <p className="font16">Choose a plan that fits your business needs. Get started today with the perfect package!</p>
        </HeaderInfo>
        <TablesWrapper className="flexSpaceNull">
          {/* Basic Package */}
          <TableBox>
            <PricingTable
              icon="roller"
              price="₨30,000"
              title="Basic"
              text="Perfect for small businesses with a limited budget, looking for a simple yet effective online presence."
              features={[
                { name: "5 Pages", checked: true },
                { name: "Simple UI/UX", checked: true },
                { name: "Contact Form", checked: true },
                { name: "Free Hosting & Domain for 1 Year", checked: true },
                { name: "1-2 Weeks Project Duration", checked: true },
                { name: "3 Months Free Maintenance", checked: true },
              ]}
              action={() => alert("clicked")}
            />
          </TableBox>

          {/* Premium Package */}
          <TableBox>
            <PricingTable
              icon="monitor"
              price="₨60,000"
              title="Premium"
              text="Ideal for businesses looking for enhanced features with custom UI/UX and SEO optimization."
              features={[
                { name: "10 Pages", checked: true },
                { name: "Custom UI/UX Design", checked: true },
                { name: "Contact Form", checked: true },
                { name: "SEO Optimization", checked: true },
                { name: "Free Hosting & Domain for 1 Year", checked: true },
                { name: "2-3 Weeks Project Duration", checked: true },
                { name: "6 Months Free Maintenance", checked: true },
              ]}
              action={() => alert("clicked")}
            />
          </TableBox>

          {/* Professional Package */}
          <TableBox>
            <PricingTable
              icon="browser"
              price="₨90,000"
              title="Professional"
              text="The ultimate package for large projects with advanced features, custom UI/UX, SEO, and chatbot integration."
              features={[
                { name: "20+ Pages", checked: true },
                { name: "Custom UI/UX Design", checked: true },
                { name: "Contact Form", checked: true },
                { name: "SEO Optimization", checked: true },
                { name: "Free Hosting & Domain for 1 Year", checked: true },
                { name: "4-7 Weeks Project Duration", checked: true },
                { name: "12 Months Free Maintenance", checked: true },
                { name: "Chatbot Integration", checked: true },
              ]}
              action={() => alert("clicked")}
            />
          </TableBox>
        </TablesWrapper>
      </div>
    </Wrapper>
  );
}

const Wrapper = styled.section`
  width: 100%;
  padding: 80px 0;
  background-color: #f7f7f7;
`;

const HeaderInfo = styled.div`
  margin-bottom: 60px;
  text-align: center;
  h1 {
    font-size: 40px;
    color: #333;
    margin-bottom: 10px;
  }
  p {
    font-size: 16px;
    color: #666;
  }
`;

const TablesWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 20px;
  @media (max-width: 860px) {
    flex-direction: column;
    gap: 30px;
  }
`;

const TableBox = styled.div`
  width: 30%;
  padding: 30px;
  background-color: #fff;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease-in-out;
  &:hover {
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.15);
    transform: translateY(-10px);
  }
  @media (max-width: 860px) {
    width: 100%;
    margin: 0 auto;
    max-width: 380px;
  }
`;

